// extracted by mini-css-extract-plugin
export default {"root":"IPocfKHN4yLcVMI70UV8","imgContainer":"cjEPdGgFpUjo88q6ulEc","image":"Cc_rTYMI1MgSoWCVsYeE","tabBar":"vzOA4Kn1oCcdpJWZTSmA"};